import { render, staticRenderFns } from "./BulkUpload.vue?vue&type=template&id=1bf397ea&scoped=true"
import script from "./BulkUpload.vue?vue&type=script&lang=ts"
export * from "./BulkUpload.vue?vue&type=script&lang=ts"
import style0 from "./BulkUpload.vue?vue&type=style&index=0&id=1bf397ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf397ea",
  null
  
)

export default component.exports